module.exports = __webpack_public_path__ + "static/media/seamless.d5b32b73.svg";